import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import {
  useFeedbackGetQuery,
  useFeedbackUpdateMutation,
} from "../../../Features/feedback/feedback-slice";
import SimpleButton from "../../../shared/components/Button/Button";
import TextArea from "../../../shared/components/TextArea";
import {
  ACTION_LABEL,
  BUTTON_LABEL,
  icons,
  LABELS,
  MESSAGE,
  toastError,
  toastSuccess,
} from "../../../shared/constants";
import { Rating } from "react-simple-star-rating";
import { customerFeedbackValidation } from "../../../shared/validation/customer-feedback-validation";
import Loader from "../../../shared/components/Loader";

const CustomerFeedback = (props: any) => {
  const {} = props;
  const { orderId } = useParams();
  let displayBlock: any;
  const [isFeedbackSubmitted, setIsFeedbackSubmitted] = useState<
    "form" | "error" | "success"
  >("error");
  const [feedbackDetailData, setFeedbackDetailData]: any = useState();
  const [customerFeedbackData, setCustomerFeedbackData]: any = useState({
    remark: "",
    rate: 0,
  });
  const [errors, setErrors]: any = useState({});
  const [updateFeedback] = useFeedbackUpdateMutation();
  const parsedOrderId = orderId ?? skipToken;
  const {
    data: getFeedbackData,
    isSuccess: getFeedbackSuccess,
    isLoading: getFeedbackLoading,
    refetch: getFeedbackRefetch,
  } = useFeedbackGetQuery(parsedOrderId, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (getFeedbackSuccess && getFeedbackData?.item && orderId) {
      setFeedbackDetailData(getFeedbackData.item);
      if (getFeedbackData.item?.isFeedback) {
        setIsFeedbackSubmitted("success");
        toastSuccess(getFeedbackData?.message);
      } else {
        setIsFeedbackSubmitted("form");
      }

      setCustomerFeedbackData({
        remark: getFeedbackData.item.remark || "",
        rate: getFeedbackData.item.rate || 0,
      });
    } else if (getFeedbackData && !getFeedbackData.item) {
      setIsFeedbackSubmitted("error");
    }
  }, [getFeedbackSuccess, getFeedbackData]);

  const updateFeedbackFlow = async (data: any) => {
    setIsFeedbackSubmitted("success");
    toastSuccess(data.message);
  };

  const handleOnChange = (e: any) => {
    setCustomerFeedbackData({
      ...customerFeedbackData,
      [e.target.name]: e.target.value,
    });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleOnBlur = (e: any) => {
    const trimmedValue = e.target.value.trim();

    setCustomerFeedbackData({
      ...customerFeedbackData,
      [e.target.name]: trimmedValue,
    });
  };

  const handleRating = (rate: number) => {
    setCustomerFeedbackData({
      ...customerFeedbackData,
      rate: rate,
    });
  };

  const handleSubmit = async () => {
    const { formErrors, formValid } =
      customerFeedbackValidation(customerFeedbackData);
    if (formValid) {
      const updateFeedbackResponse = await updateFeedback({
        id: orderId,
        data: customerFeedbackData,
      })
        .unwrap()
        .catch((err: any) => {
          toastError(err.data?.errors[0]?.msg);
        });
      if (updateFeedbackResponse && updateFeedbackResponse?.status) {
        updateFeedbackFlow(updateFeedbackResponse);
      }
    } else {
      setErrors(formErrors);
    }
  };
  const handleCancel = () => {};

  switch (isFeedbackSubmitted) {
    case "form":
      displayBlock = (
        <>
          <div className="row mb-3">
            <div className="col-12 col-md-4 mx-auto">
              <div className="page-title mb-4">
                {feedbackDetailData?.documentNo}
              </div>
              <div className="form-group">
                <TextArea
                  name={ACTION_LABEL.REMARK}
                  placeholder={MESSAGE.CUSTOMER_FEEDBACK_TEMPLATE_MESSAGE}
                  id={LABELS.REMARKS_TEXT}
                  label={LABELS.REMARKS_TEXT}
                  onChange={handleOnChange}
                  onBlur={handleOnBlur}
                  value={customerFeedbackData.remark}
                />
              </div>
              <div className="form-group text-center">
                <div className="form-group text-center">
                  <Rating
                    onClick={handleRating}
                    initialValue={customerFeedbackData.rate || 0}
                    allowFraction
                    fillColor="#facc15"
                    emptyColor="#e5e7eb"
                    size={30}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <SimpleButton
              className="btn theme-btn theme-btn-sm me-2"
              onClick={handleSubmit}
              text={BUTTON_LABEL.SUBMIT}
            />
            <SimpleButton
              className="btn theme-btn theme-btn-sm me-2"
              onClick={handleCancel}
              text={BUTTON_LABEL.CANCEL}
            />
          </div>
        </>
      );
      break;
    case "error":
      displayBlock = (
        <>
          <div className="page-full">
            <div className="feedback-msg error mt-5">
              <i>!</i>
            </div>
            <div className="text-center">
              <h1>{LABELS.OOPS_TEXT}!</h1>

              <p className="mt-3">{MESSAGE.ORDER_NOT_FOUND_MESSAGE}</p>
            </div>
          </div>
        </>
      );
      break;
    case "success":
      displayBlock = (
        <>
          <div className="page-full">
            <div className="feedback-msg success mt-5">
              <i className={icons.ICON_CHECK} />
            </div>
            <div className="text-center">
              <h2>{MESSAGE.FEEDBACK_SUBMIT_MESSAGE}</h2>
            </div>
          </div>
        </>
      );
      break;
  }

  return (
    <>
      {getFeedbackLoading ? (
        <Loader />
      ) : (
        <div className="login-wrapper">{displayBlock}</div>
      )}
    </>
  );
};

export default CustomerFeedback;
